import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'
import DateTime from './_date-time.js'
import SportIcons from './_sport-icons.js'

export default {
  name: 'SearchResultItem',
  values: {
    button: {
      configSet: Button,
      configValues: {
        enableAHref: true,
        style: {
          base: {
            justifyContent: 'left',
            flexGrow: 1,
            minHeight: '32px',
            padding: '8px 12px',
            _mobile_padding: '8px 16px',
          },
        },
      },
    },
    searchNamesContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexGrow: 1,
        },
      },
    },
    searchItemIcon: {
      configSet: Image,
      configValues: {
        style: {
          flexBasis: '24px',
          flexShrink: 0,
          alignSelf: 'stretch',
          padding: '5px 8px 5px 0',
        },
      },
    },
    parentText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    nameText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    sportNameText: {
      configSet: Text,
      configValues: {
        container: {
          padding: '6px 0',
        },
      },
    },
    infoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '6px',
        style: {
          alignItems: 'flex-end',
          flexDirection: 'column',
          flexGrow: 0,
          flexShrink: 0,
          padding: ' 0 0 0 8px',
        },
      },
    },
    live: {
      configSet: Text,
      configValues: {},
    },
    startDate: {
      configSet: Text,
      configValues: {},
    },
    startTime: {
      configSet: Text,
      configValues: {},
    },
    startDateFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_DATE',
      },
    },
    startTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
